<template>
	<div>

		<!-- yay nav! -->
		<Nav />

		<!-- loading component -->
		<div id='loader' v-if="!dataIsReady" />

		<!-- title + snapshot -->
		<div id='title'>
			<div class='container'>
				<div class='section'>
					<div id='profile-header-div'>
						<p class='profile-title'> {{ activeLeaData.lea_name }} </p>
						<p class='profile-subtitle'>{{ activeLeaData.county_name }} County</p>
					</div>
				</div>
			</div>
		</div>

		<Snapshot />

		<!-- so what? -->
		<div id='about'>
			<div class='container'>
				<div class='section'>
					<div class='columns is-centered'>
						<div class='column is-6-desktop is-8-tablet'>
							<div class='profile-h1-div'>
								<p class='profile-h1' id='about-title'>Why does this matter?</p>
							</div>
							<p>
								Each of these areas represents a potential entry point into the school-to-prison-pipeline. Once students are caught in the pipeline, it can be very difficult for them to re-engage and be successful at school.
							</p>
							<br> 
							<p>
								Statewide, students of color are overrepresented at each entry point. There are many reasons for this, including implicit racial bias of decision-makers, institutional and structural racism, and explicit discrimination against people of color.
							</p>
							<br>
							<p>
								This report card serves as a call-to-action for students, parents, advocates, policy-makers, and institutional stakeholders to examine the causes of racial inequity in their community and to develop solutions that will help young people, especially youth of color, avoid and escape the school-to-prison-pipeline.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>


		<Domains />

	</div>
</template>

<script>
import Nav from './Nav.vue';
import Snapshot from './Snapshot.vue';
import Domains from './Domains.vue';

import { mapState, mapActions } from "vuex";
import { setProfileComponentScrollTriggers } from '../js/scroll.js';

export default {
	components: {
		Nav,
		Snapshot,
		Domains
	},
	props: {
		leaId: String,
	},
	async mounted() {
		// always reload at top
		window.scrollTo(0, 0);

		// make the api call
		try {
			await this.getActiveLea(this.leaId);
		} catch {
			console.log('oops')
		} finally {
			this.dataIsReady = true;
			setProfileComponentScrollTriggers();
		}
	},
	computed: {
		...mapState(['activeLeaData']),
	},
	methods: {
		...mapActions(['getActiveLea']),
	},
	data() {
		return {
			dataIsReady: false
		}
	}
}
</script>